import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import TaskEdit from "../TaskEdit";
import axios from "axios";

const RestituitCerereTab = () => {
  const [rows, setRows] = useState([]);
  const [selectedCerereId, setSelectedCerereId] = useState(null);
  const [selectedEmail, setSelectedEmail] = useState(null);

  useEffect(() => {
    const fetchRestituiri = async () => {
      try {
        const response = await axios.get(
          "https://server-9p4hx.kinsta.app/api/stocmanager/cerere-restituit/restituiri"
        );
        setRows(response.data);
      } catch (error) {
        console.error("Eroare la preluarea restituirilor:", error);
      }
    };

    fetchRestituiri();
  }, []);

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Typography variant="h6" sx={{ p: 2, fontWeight: "bold" }}>
          Restituiri
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <b>ID</b>
              </TableCell>
              <TableCell>
                <b>Nume</b>
              </TableCell>
              <TableCell>
                <b>Telefon</b>
              </TableCell>
              <TableCell>
                <b>Email</b>
              </TableCell>
              <TableCell>
                <b>Status</b>
              </TableCell>
              <TableCell>
                <b>AWB Tracking</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={index}
                hover
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setSelectedCerereId(row.id);
                  setSelectedEmail(row.email);
                }}
              >
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.nume}</TableCell>
                <TableCell>{row.telefon}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.awb || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {selectedCerereId && (
        <Box sx={{ mt: 4 }}>
          <TaskEdit
            cerereId={selectedCerereId}
            email={selectedEmail}
            emailFromRestituit={selectedEmail}
            tab="restituiri"
          />
        </Box>
      )}
    </>
  );
};

export default RestituitCerereTab;
